import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function PrivacyPolicyPage() {
  return (
    <section className="legal-page" aria-labelledby="privacy-heading">
      <div className="legal-inner">
        <h1 id="privacy-heading">Privacy Policy</h1>
        <p className="legal-updated">Last updated: 8 August 2026</p>

        <p>
          SnapScrap (“we”, “us”, “our”) respects your privacy. This policy explains how we collect,
          use, and protect personal information when you use our scrap posting and collector
          matching services.
        </p>

        <h2>Information we collect</h2>
        <ul>
          <li>Contact details such as name, email address, and phone number</li>
          <li>Location details such as postcode and collection address</li>
          <li>Scrap listing details, photos, and preferred collection times</li>
          <li>Collector licence, vehicle, and coverage information</li>
          <li>Technical data such as browser type and usage analytics</li>
        </ul>

        <h2>How we use your information</h2>
        <ul>
          <li>To create and manage scrap posts and collector applications</li>
          <li>To match posters with collectors and arrange collections</li>
          <li>To respond to enquiries and provide customer support</li>
          <li>To improve our website, safety checks, and service quality</li>
          <li>To meet legal and regulatory obligations where required</li>
        </ul>

        <h2>Sharing your information</h2>
        <p>
          We only share information needed to complete a collection or operate the platform — for
          example, sharing a scrap post location with a matched collector. We do not sell your
          personal data.
        </p>

        <h2>Your rights</h2>
        <p>
          You may request access, correction, or deletion of your personal data. To make a request,
          contact us via our <Link to="/contact">Contact</Link> page.
        </p>

        <h2>Contact</h2>
        <p>
          Questions about this policy can be sent to{' '}
          <a href="mailto:cs@snapscrap.co.uk">cs@snapscrap.co.uk</a>.
        </p>
      </div>
    </section>
  );
}
